<template>
  <div :id="componentId" class="sp2-module-3" :style="moduleStyle">
    <div class="sp2-module-3-wrap">
      <div class="sp2-avatar-section">
        <div class="sp2-avatar-wrap">
          <img
            v-if="avatarUrl"
            class="sp2-avatar-image"
            referrerpolicy="no-referrer"
            :src="avatarUrl"
          />
          <div v-else class="sp2-avatar-placeholder">头像</div>
        </div>
        <div class="sp2-avatar-info">
          <div class="sp2-avatar-name">{{ name || '姓名' }}</div>
          <div class="sp2-avatar-divider" />
          <div class="sp2-avatar-position">{{ position || '职位' }}</div>
        </div>
      </div>

      <div class="sp2-chart-section">
        <img
          v-if="imageUrl"
          class="sp2-chart-image"
          referrerpolicy="no-referrer"
          :src="imageUrl"
        />
        <div v-else class="sp2-chart-placeholder">请配置图片</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpTwoModule3',
  props: {
    componentId: {
      type: String,
      default: 'sp_two_module_3'
    }
  },
  data() {
    return {
      backgroundColor: '#fff',
      avatarUrl: '',
      name: '寇 枫',
      position: '中国品牌杂志社 总编辑',
      imageUrl: ''
    };
  },
  computed: {
    moduleStyle() {
      return {
        backgroundColor: this.backgroundColor
      };
    }
  }
};
</script>

<style scoped>
.sp2-module-3 {
  position: relative;
  width: 100%;
  padding: 16px 0;
  box-sizing: border-box;
  overflow: hidden;
}

.sp2-module-3-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: calc(100% - 24px);
  margin: 0 auto;
  padding: 24px 0;
  gap: 20px;
  box-sizing: border-box;
}

.sp2-avatar-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
}

.sp2-avatar-wrap {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  background: #e0e0e0;
}

.sp2-avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.sp2-avatar-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
}

.sp2-avatar-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
  flex: 0 1 auto;
  min-width: 0;
}

.sp2-avatar-name {
  font-size: 20px;
  color: #000000;
  line-height: 1.4;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sp2-avatar-divider {
  width: 28px;
  height: 3px;
  background: linear-gradient(90deg, #1F48BC 0%, #6592E3 100%);
  border-radius: 2px;
}

.sp2-avatar-position {
  font-size: 14px;
  color: #666666;
  line-height: 1.5;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sp2-chart-section {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  background: #e0e0e0;
}

.sp2-chart-image {
  width: 100%;
  height: auto;
  object-fit: contain;
  display: block;
}

.sp2-chart-placeholder {
  width: 100%;
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
}
</style>
